module.exports = __webpack_public_path__ + "img/yiyongyou.2dfa4788.svg";